import { getIntlDateTimeFormat } from '../intl/date';
import { getIntlRelativeTimeFormat } from '../intl/relative-time';

export function getDateFormatter(locale: string = 'default', options?: Intl.DateTimeFormatOptions) {
  return getIntlDateTimeFormat(locale, options);
}

export function getRelativeTimeFormatter(locale: string = 'default', options?: Intl.RelativeTimeFormatOptions) {
  return getIntlRelativeTimeFormat(locale, options);
}
